export function formatCourse(jsonRouteList) {
  return jsonRouteList.map((route) => {
    if (route.path === "course") {
      return {
        path: "course",
        name: route.name,
        redirect: "/course/courseindex",
        children: [
          {
            path: "courseindex",
            name: "课程列表",
            component: route.component, // 原来的组件作为子路由
            meta: {
              hidden: true,
            },
          },
        ],
      };
    }
    if (route.path === "simulation") {
      return {
        path: "simulation",
        name: route.name,
        redirect: "/simulation/simulationindex",
        children: [
          {
            path: "simulationindex",
            name: "虚仿列表",
            component: route.component, // 原来的组件作为子路由
            meta: {
              hidden: true,
            },
          },
        ],
      };
    }
    return route;
  });
}
